import { Component, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-organization-share-copy-link',
  templateUrl: './copy-link.component.html',
  styleUrls: [
    './copy-link.component.scss',
    '../../property-share-modal/copy-link/copy-link.component.scss',
  ],
})
export class OrganizationShareCopyLinkComponent {
  @Input({ required: true }) orgUrl: string = '';

  protected copied = false;

  constructor(private clipboard: Clipboard) {}

  copyValue() {
    this.clipboard.copy(this.orgUrl);
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 3000);
  }
}
